import lazyLoadAttribute from './lazyLoadAttribute';
import config from './utils/config';
import * as eventListeners from './utils/event-listeners';

window.OptanonWrapper = function() {}

window._sw_events = eventListeners;
window._sw_config = config;
require('./$sw');

document.dispatchEvent(new CustomEvent('assets.loaded'));

function main() {
    console.log(
        '%c            ;;;\n          ;;;;;;;                                   ;;;                           ;;;\n         ;;;   ;;;                                  ;;;                           ;;;\n         ;;;      ;;;   ;;;   ;;;  ;;;;;    ;;;;;  ;;;;;;:;;   ;;;   ;;;  ;;;;;  ;;;;;;  ;;;;;  ;;; ;;\n          ;;;;;;   :;; ;;:;; :;; ;;;   ;; ;;;   ;;; ;;;   ;;; ;; ;; ;;;      ;;;  ;;;  ;;;   ;; ;;;\n             :;;;; ;;; ;; ;; ;;; ;;;;;;;; ;;;;;;;;; ;;;    ;; ;; ;; ;;;  ;;;;;;;  ;;;  ;;;;;;;;;;;;\n               ;;; ;;;,;; ;;,;;; ;;;      ;;;       ;;;    ;; ;; ;; ;;: ;;;  ;;;  ;;;  ;;;      ;;;\n         ;;;   ;;;  ;;;;;  ;;;;  ;;;  ;;; ;;;   ;;; ;;;    ;;;;;  ;;;;  ;;:  ;;;  ;;;  ;;;   ;; ;;;\n         :;;;;;;;    ;;;   ;;;    ;;;;;;   ;;;;;;;   ;;;;   ;;;    ;;    ;;;;;;;   ;;;; ;;;;;;  ;;;\n           :;;;',
        'color: #2380A9;',
    );
    console.log(
        '%c                   ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;  ;;;;\n                 :;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n        :;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::                    ::;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n     ;;;;;;;;;;;:                                                                               ;;;;;;\n                                                                                                  ;;;',
        'color: red;',
    );

    // load onetrust
    require('./onetrust');

    // load polyfills
    require('./polyfill');

    // Makes a request to the profiling endpoint and dispatches an
    // event with details about the profiling response.
    require('./profiling');

    // Runs the google tag manager and google analytics scripts and sets up dataLayer.
    require('./googleAnalytics');

}

const assetsAppJsHasMountedKey = '_assets_app_js_has_mounted';
if (!window[assetsAppJsHasMountedKey]) {
    window[assetsAppJsHasMountedKey] = true;
    lazyLoadAttribute('src');
    lazyLoadAttribute('style');
    lazyLoadAttribute('loaded');
    main();
}

export function isSpanish(locale) {
    return locale.startsWith('es');
}
